import { ResponsiveGrid, Tab } from '@alifd/next';
import React from 'react';

import PageHeader from '@/components/PageHeader';
import EditDocument from '@/components/UI/EditDocument';

import {
  CompanyRating,
  QuestionnaireList,
  QuestionnaireStatistics,
} from '../Questionnaire/Desktop';
import Dashboard from './components/Dashboard';
import ISOZone from './components/ISOZone';
import styles from './index.module.scss';

const { Cell } = ResponsiveGrid;

const SmartBuildingEffectiveness = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="效能管理"
        breadcrumbs={[
          {
            name: '智慧建築專區',
          },
          {
            name: '效能管理',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <Tab>
        <Tab.Item title="績效評估">
          <div className={styles.content}>
            <h2>問卷列表管理</h2>
            <QuestionnaireList showHeader={false} />
          </div>
          <div className={styles.content}>
            <h2>問卷統計列表</h2>
            <QuestionnaireStatistics showHeader={false} />
          </div>
          <div className={styles.content}>
            <h2>廠商評分</h2>
            <CompanyRating showHeader={false} />
          </div>
        </Tab.Item>
        <Tab.Item title="資料收集記錄">
          <div className={styles.content}>
            <h2>資料收集記錄</h2>
            <EditDocument name="資料收集" style={{ marginBottom: 10 }} />
            <Dashboard />
          </div>
        </Tab.Item>
        <Tab.Item title="ISO品質專區">
          <div className={styles.content}>
            <h2>ISO品質專區</h2>
            <EditDocument name="品質管理制度" style={{ marginBottom: 10 }} />
            <ISOZone />
          </div>
        </Tab.Item>
      </Tab>
    </Cell>
  </ResponsiveGrid>
);

export default SmartBuildingEffectiveness;
